export function attachedRoot (node: Node): Node | null {
  if (typeof node.getRootNode !== 'function') {
    while (node.parentNode) {
      node = node.parentNode;
    }

    if (node !== document) {
      return null;
    }

    return document;
  }

  const root = node.getRootNode();

  if (root !== document && root.getRootNode({ composed: true }) !== document) {
    return null;
  }

  return root;
}
